import {connect} from 'react-redux';
import ReactModal from 'react-modal';
import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import {
    restorePasswordFirstStep,
    changeVisibleRestorePasswordFirstStep
} from '../../actions/User';

const defaultProps = {
    closeModal: closeModal => {
    }
};

class RestorePasswordFirstStep extends Component {
    closeModal(event) {
        event.preventDefault();

        this.props.changeVisibleRestorePasswordFirstStep(false);
    }


    handleRestorePassword(event) {
        event.preventDefault();

        this.props.restorePasswordFirstStep(this.email.value);
        this.props.changeVisibleRestorePasswordFirstStep(false);
    }

    render() {
        const i18n = this.props.i18n;
        return (
            <ReactModal
                className="popup enter"
                overlayClassName="popup-overlay"
                isOpen={this.props.isShowRestorePasswordFirstStep}
            >
                <div onClick={(event) => this.closeModal(event)} className="popup-close"/>
                <div className="popup-title">
                    Restore Password
                </div>

                <form>
                    <input
                        type="email"
                        placeholder="E-mail"
                        className="text-field"
                        ref={ref => {
                            this.email = ref
                        }}
                    />

                    <div className="submit-box">
                        <button className="btn" type="submit" onClick={::this.handleRestorePassword}>
                            Send Email With Instruction
                        </button>
                    </div>
                </form>
            </ReactModal>
        )
    }
}

RestorePasswordFirstStep.defaultProps = defaultProps;

const mapStateToProps = state => ({
    i18n: state.languages.i18n,
    isShowRestorePasswordFirstStep: state.user.isShowRestorePasswordFirstStep,
    isShowWrongDataMessage: state.user.isShowWrongDataMessage
});

const mapDispatchToProps = {
    restorePasswordFirstStep,
    changeVisibleRestorePasswordFirstStep
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RestorePasswordFirstStep));



// WEBPACK FOOTER //
// ./src/components/Base/RestorePasswordFirstStep.js